import React, { useState, useEffect, useRef, useContext } from "react";
import { Button, ButtonGroup, Modal, Row, Col, Form } from 'react-bootstrap';
import { PollContext } from "./App";
import { UserInformationContext } from "./App";
import { SitterUserInformationContext } from "./App";
import { C4FStatusContext } from "./App";
import C4FSimpleTable from "../common/C4FSimpleTable";
import C4FSimpleTextField from "../common/C4FSimpleTextField";
import C4FReferenceDataSelection from "../common/C4FReferenceDataSelection";
import { currentISODate, isAdmin, isNumber, max, resultEmoji, sum, truncateString } from "../common/Helpers";
import moment from "moment";

function PollModal(props) {

    const mounted = useRef(false);
    const { polls, setPolls, refreshPolls } = useContext(PollContext);
    const { userInformation } = useContext(UserInformationContext);
    const { sitterUserInformation } = useContext(SitterUserInformationContext);
    const { handleBackendRequest } = useContext(C4FStatusContext);
    const handleClose = () => props.handleClose();
    const [initialized, setInitialized] = useState(false);
    const [tab, setTab] = useState('overview');
    const [selectedPoll, setSelectedPoll] = useState(null);
    const [selectedPollItem, setSelectedPollItem] = useState(null);
    const [selectedPollItemOption, setSelectedPollItemOption] = useState(null);
    const [hasUnsavedChanges, setHasUnsavedChanges] = useState(false);

    const statusListDesign = ['Draft', 'Submitted', 'Cancelled'];    
    const statusListCompleted = ['Completed', 'Archived'];    

    function handleSetSelectedPoll(poll, tab = 'details') {
        setSelectedPoll(poll);
        if (poll && statusListDesign.includes(poll.status)) {
            setSelectedPollItem(poll?.items?.length > 0 ? poll.items[0] : null);
            setSelectedPollItemOption(poll?.items?.length > 0 && poll?.items[0]?.options?.length > 0 ? poll.items[0].options[0] : null);
        }
        else {
            setSelectedPollItem(null);
            setSelectedPollItemOption(null);
        }
        setTab(tab);
    }

    const editPollAllowed = () => selectedPoll && userInformation && selectedPoll.createdByUserId === userInformation.userID && selectedPoll.status === 'Draft' && !sitterUserInformation;
    const votingAllowed = () => selectedPoll && selectedPoll.status === 'InProgress' && selectedPoll.eligible && 
        (!selectedPoll.voted || selectedPoll.allowChanges) && !sitterUserInformation;
    const reativatePollAllowed = () => selectedPoll && userInformation && selectedPoll.createdByUserId === userInformation.userID && selectedPoll.status === 'Cancelled' && !sitterUserInformation;
    const unsavedChanges = () => { if (!hasUnsavedChanges) setHasUnsavedChanges(true); }

    function addPoll() {
        let poll = {
            id: 'newpoll',
            type: 'Regular',
            status: 'Draft',
            title: '',
            description: '',
            createdByUserId: userInformation.userID,
            createdByUserName: userInformation.userName,
            startDate: currentISODate,
            duration: 7,
            allowChanges: false,
            isAnonymous: false,
            resultsAvailable: 'Always',
            userRestriction: 'None',
            items: [{
                number: 1,
                type: 'MultipleChoice',
                question: '',
                minAnswers: 1,
                maxAnswers: 1,
                options: [{
                    number: 1,
                    answer: ''
                }]
            }]
        };
        setSelectedPoll(poll);
        setSelectedPollItem(poll.items[0]);
        setSelectedPollItemOption(poll.items[0].options[0]);
        setTab('details');
        unsavedChanges();
    }
    function addPollItem() {
        let updatedPoll = structuredClone(selectedPoll);
        let newPollItem = {
            number: max(updatedPoll.items.map(pi => pi.number)) + 1,
            type: 'MultipleChoice',
            question: '',
            minAnswers: 1,
            maxAnswers: 1,
            options: [{
                number: 1,
                answer: ''
            }]
        };
        updatedPoll.items.push(newPollItem);        
        setSelectedPoll(updatedPoll);
        setSelectedPollItem(newPollItem);
        setSelectedPollItemOption(newPollItem.options[0]);
        unsavedChanges();
    }
    function deletePollItem() {
        if (!selectedPollItem || selectedPoll.items.length <= 1)
            return;
        let updatedPoll = structuredClone(selectedPoll);
        updatedPoll.items = updatedPoll.items.filter(pi => pi.number !== selectedPollItem.number);

        setSelectedPoll(updatedPoll);
        setSelectedPollItem(updatedPoll.items.length > 0 ? updatedPoll.items[0] : null);
        setSelectedPollItemOption(updatedPoll.items.length > 0 && updatedPoll.items[0].options.length > 0 ? updatedPoll.items[0].options[0] : null);
        unsavedChanges();
    }

    function addPollItemOption() {
        let updatedPollItem = structuredClone(selectedPollItem);
        let newPollItemOption = {
            number: max(updatedPollItem.options.map(pio => pio.number)) + 1,
            answer: ''
        };
        updatedPollItem.options.push(newPollItemOption);

        replacePollItemInPoll(updatedPollItem)
        setSelectedPollItem(updatedPollItem);
        setSelectedPollItemOption(newPollItemOption);
        unsavedChanges();
    }
    function deletePollItemOption() {
        if (!selectedPollItemOption || selectedPollItem.options.length <= 1)
            return;
        let updatedPollItem = structuredClone(selectedPollItem);
        updatedPollItem.options = updatedPollItem.options.filter(pio => pio.number !== selectedPollItemOption.number);

        replacePollItemInPoll(updatedPollItem)
        setSelectedPollItem(updatedPollItem);
        setSelectedPollItemOption(updatedPollItem.options.length > 0 ? updatedPollItem.options[0] : null);
        unsavedChanges();
    }

    function replacePollItemInPoll(pollItem) {
        let updatedPoll = structuredClone(selectedPoll);
        updatedPoll.items = 
            updatedPoll.items.filter(pi => pi.number < pollItem.number)
                .concat([pollItem])
                .concat(updatedPoll.items.filter(pi => pi.number > pollItem.number));
        setSelectedPoll(updatedPoll);
        unsavedChanges();
    }
    function replacePollItemOptionInPollItem(pollItemOption) {
        let updatedPollItem = structuredClone(selectedPollItem);
        updatedPollItem.options = 
            updatedPollItem.options.filter(pio => pio.number < pollItemOption.number)
                .concat([pollItemOption])
                .concat(updatedPollItem.options.filter(pio => pio.number > pollItemOption.number));
        setSelectedPollItem(updatedPollItem);
        replacePollItemInPoll(updatedPollItem);
        unsavedChanges();
    }

    function updatePoll(key, value) {
        let updatedPoll = structuredClone(selectedPoll);
        updatedPoll[key] = value;
        setSelectedPoll(updatedPoll);
        unsavedChanges();
    }
    function updatePollItem(key, value) {
        let updatedPollItem = structuredClone(selectedPollItem);
        updatedPollItem[key] = value;
        if (key === 'type' && value === 'FreeText') {
            updatedPollItem.minAnswers = 1;
            updatedPollItem.maxAnswers = 1;
            updatedPollItem.options = [];
        }
        else if (key === 'type' && value === 'MultipleChoice') {
            updatedPollItem.minAnswers = 1;
            updatedPollItem.maxAnswers = 1;
            updatedPollItem.options = [{
                number: 1,
                answer: 'first option'
            }];
            setSelectedPollItemOption(updatedPollItem.options[0]);
        }
        replacePollItemInPoll(updatedPollItem);
        setSelectedPollItem(updatedPollItem);
        unsavedChanges();
    }
    function updatePollItemOption(key, value) {
        let updatedPollItemOption = structuredClone(selectedPollItemOption);
        updatedPollItemOption[key] = value;
        replacePollItemOptionInPollItem(updatedPollItemOption);
        setSelectedPollItemOption(updatedPollItemOption);
        unsavedChanges();
    }

    function updateSelectedOptions(option, result) {
        let updatedPollItem = structuredClone(selectedPollItem);
        if (!updatedPollItem.answer)
            updatedPollItem.answer = [];
        if (result && !updatedPollItem.answer.includes(option)) {
            if (updatedPollItem.answer.length >= updatedPollItem.maxAnswers) 
                updatedPollItem.answer.splice(-1);    
            updatedPollItem.answer.push(option);
        }
        else if (!result && updatedPollItem.answer.includes(option))
            updatedPollItem.answer.splice(updatedPollItem.answer.indexOf(option), 1);

        replacePollItemInPoll(updatedPollItem);
        setSelectedPollItem(updatedPollItem);
        unsavedChanges();
    }

    function pollItemStatus(pollItem) {
        pollItem = pollItem ? pollItem : selectedPollItem
        if (pollItem.type === 'FreeText')
            return pollItem.minAnswers === 0 || pollItem.answer.length > 0;
        else
            return pollItem.answer.length >= pollItem.minAnswers && pollItem.answer.length <= pollItem.maxAnswers;
    }

    function isPollValid(poll = null) {
        poll = poll ?? selectedPoll;
        console.log(poll);
        return poll && validatePollParameter('title', poll) &&
            validatePollParameter('description', poll) &&
            validatePollParameter('reviewComment', poll) &&
            validatePollParameter('duration', poll) &&
            poll.items.every(i => 
                validatePollItemParameter('question', i, poll) &&
                validatePollItemParameter('answer', i, poll) &&
                validatePollItemParameter('minAnswers', i, poll) &&
                validatePollItemParameter('maxAnswers', i, poll));
    }
    function validatePollParameter(key, poll = null) {
        poll = poll ?? selectedPoll;
        
        switch (key) {
            case 'title': return (poll.title ?? '').match('^.{1,60}$');
            case 'description': return (poll.description ?? '').match('^.{1,300}$');
            case 'reviewComment': return (poll.reviewComment ?? '').match('^.{0,120}$');
            case 'duration': return isNumber(poll.duration) && poll.duration >= 1 && poll.duration <= 30;            
            default: return true;
        }
    }    
    function validatePollItemParameter(key, pollItem = null, poll = null) {
        poll = poll ?? selectedPoll;
        pollItem = pollItem ?? selectedPollItem;
        switch (key) {
            case 'question': return pollItem.question.match('^.{1,120}$');
            case 'answer': return pollItem.type === 'MultipleChoice' || (pollItem.answer ?? '').match('^.{' + (statusListDesign.includes(poll.status) ? 0 : pollItem.minAnswers) + ',120}$');
            case 'minAnswers': 
            case 'maxAnswers': 
                return isNumber(pollItem.minAnswers) &&
                    isNumber(pollItem.maxAnswers) &&
                    pollItem.minAnswers >= 0 &&
                    pollItem.minAnswers <= pollItem.maxAnswers &&
                    (pollItem.type === 'MultipleChoice' && pollItem.maxAnswers <= pollItem.options.length ||
                    pollItem.type === 'FreeText' && pollItem.maxAnswers === 1);            
            default: return true;
        }        
    }
    function afterSaveProcessing(poll) {
        setPolls(polls.filter(p => p.id !== poll.id).concat([poll]));
        handleSetSelectedPoll(poll);
        setHasUnsavedChanges(false);
    }
    function transitionPoll(status) {
        let poll = selectedPoll;
        poll.status = status;
        if (status === 'Approved')
            poll.approvedByUserId = userInformation.userID;
        savePoll(poll);
    }
    function savePoll(poll) {
        poll = poll ? poll : selectedPoll;
        handleBackendRequest('POST', '/poll/' + poll.id, poll, { userName: userInformation.userName }, afterSaveProcessing);        
    }
    function revertChanges() {
        handleSetSelectedPoll(polls.find(p => p.id === selectedPoll.id), 'overview');        
    }
    function cancelVote() {
        // different service call
    }
    function submitVote() {
        handleBackendRequest('POST', '/poll/' + selectedPoll.id + '/vote', selectedPoll, { userName: userInformation.userName }, afterSaveProcessing);
    }
    function resetVote() {
        let currentPoll = structuredClone(selectedPoll);
        currentPoll.items = currentPoll.items.map(i => ({
            ...i,
            answer: i.type === 'FreeText' ? '' : []
        }));
        console.log(currentPoll);
        setSelectedPoll(currentPoll);
        setSelectedPollItem(null);
    }
    function cancelPoll() {
        setSelectedPoll(null);
        setSelectedPollItem(null);
        setSelectedPollItemOption(null);
        setTab('overview');
    }

    function backToPreviousItem() {
        if (selectedPollItem.number > 1)
            setSelectedPollItem(selectedPoll.items[selectedPollItem.number - 2]);
        else 
            setSelectedPollItem(null);
    }
    function continueToNextItem() {
        if (selectedPollItem.number < selectedPoll.items.length)
            setSelectedPollItem(selectedPoll.items[selectedPollItem.number]);
        else 
            setSelectedPollItem(null);
    }

    useEffect(() => {
        mounted.current = true;
    }, []);

    useEffect(() => {
        return () => mounted.current = false;
    }, []);

    useEffect(() => {
        if (polls && polls.length > 0 && !initialized) {
            let selectedPoll = polls[0];
            handleSetSelectedPoll(selectedPoll, 'overview');
            setInitialized(true);
        }
    }, [polls, initialized]);

    // refresh selected poll after refreshing all polls
    useEffect(() => {
        if (polls && selectedPoll) 
            handleSetSelectedPoll(polls.find(p => p.id === selectedPoll.id), 'overview');        
    }, [polls]);

    useEffect(() => {
        if (polls && polls.some(p => p.id === props.pollId))
            handleSetSelectedPoll(polls.find(p => p.id === props.pollId));
    }, [props.pollId]);

    return <>
        {mounted.current ?
            <Modal key={'pollModal'}
                size="xl"
                show={props.show}
                onHide={handleClose} >
                <Modal.Body key={'modalBody'} closeButton style={{ backgroundColor: 'rgba(222,233,244,1)' }}>
                    <Row className="mb-2">
                        <Col>
                            <ButtonGroup className="mt-1" size="sm">
                                <Button variant={(tab !== 'overview' ? 'outline-' : '') + 'primary'} onClick={() => setTab('overview')}>All Polls</Button>
                                <Button variant={(tab !== 'details' ? 'outline-' : '') + 'primary'} onClick={() => setTab('details')}>Details</Button>
                            </ButtonGroup>
                        </Col>
                    </Row>
                    {tab === 'overview' && polls ? 
                        <Row>
                            <Col>
                                <C4FSimpleTable 
                                    key={'polls'}
                                    highlightCriteriaKey={selectedPoll ? 'id' : null}
                                    highlightCriteriaValue={selectedPoll ? selectedPoll.id : null}
                                    hideFilterButtons={false}
                                    hideColumnVisibility={true}
                                    addRecord={addPoll}
                                    refreshTable={refreshPolls}
                                    data={polls.map(p => ({
                                        ...p,
                                        titleFormatted: truncateString(p.title, 30),
                                        descriptionFormatted: truncateString(p.description, 40),
                                        createdByUserNameFormatted: truncateString(p.createdByUserName, 20),
                                        numberOfQuestions: p.items.length,
                                        votedFormatted: resultEmoji(p.voted ? 'OK' : 'NOK')
                                    }))}
                                    rowMetadata={[
                                        { columnName: 'titleFormatted', columnDescription: 'Title', cellClickEvent: handleSetSelectedPoll },
                                        { columnName: 'descriptionFormatted', columnDescription: 'Description', cellClickEvent: handleSetSelectedPoll },
                                        { columnName: 'status', columnDescription: 'Status' },
                                        { columnName: 'createdByUserNameFormatted', columnDescription: 'Created By' },
                                        { columnName: 'numberOfQuestions', columnDescription: '# Questions' },
                                        { columnName: 'totalParticipants', columnDescription: '# Votes' },
                                        { columnName: 'votedFormatted', columnDescription: 'Voted' },
                                    ]}
                                />
                            </Col>
                        </Row>
                    : null }
                    {tab === 'details' && selectedPoll && statusListDesign.includes(selectedPoll.status) ? 
                        <>
                            <h5>{editPollAllowed() ? 'Edit poll ' : ''}{selectedPoll.title + ' (ID: ' + selectedPoll.id + ' - ' + selectedPoll.status + ')'} {selectedPoll.status === 'Submitted' ? ' - pending approval' : ''}</h5>
                            <Row className="mt-1">
                                <Col>
                                    <C4FSimpleTextField
                                        disabled={!editPollAllowed()}
                                        key={'titlePoll'}
                                        info={'title of the poll, to be shown in the poll list, use a concise title'}
                                        name={'title'}
                                        displayName={'Title'}
                                        value={selectedPoll.title}
                                        validationMethod={validatePollParameter}
                                        updateMethod={updatePoll} />
                                </Col>
                            </Row>
                            <Row className="mt-1">
                                <Col>
                                    <C4FSimpleTextField
                                        disabled={!editPollAllowed()}
                                        key={'descriptionPoll'}
                                        info={'additional description of the poll, shown when participants vote'}
                                        name={'description'}
                                        displayName={'Description'}
                                        value={selectedPoll.description}
                                        validationMethod={validatePollParameter}
                                        updateMethod={updatePoll} />
                                </Col>
                            </Row>
                            <Row className="mt-1">
                                <Col>
                                    <C4FReferenceDataSelection
                                        disabled={!editPollAllowed()}
                                        key={'resultsAvailablePoll'}
                                        info={'indicates, when the results of a poll will be available to a user'}
                                        name={'resultsAvailable'}                                    
                                        displayName={'Results'}
                                        value={selectedPoll.resultsAvailable}
                                        referenceDataValues={['Always', 'AfterVoting', 'AfterCompletion', 'Never']}
                                        updateMethod={updatePoll}
                                        validationMethod={validatePollParameter}
                                    />
                                </Col>
                                <Col>
                                    <C4FSimpleTextField
                                        disabled={!editPollAllowed()}
                                        type="date"
                                        key={'startDatePoll'}
                                        info={'start date (midnight C4F time) of the poll'}
                                        name={'startDate'}
                                        displayName={'Start'}
                                        value={selectedPoll.startDate}
                                        validationMethod={validatePollParameter}
                                        updateMethod={updatePoll} />
                                </Col>
                                <Col>
                                    <C4FSimpleTextField
                                        disabled={!editPollAllowed()}
                                        key={'durationPoll'}
                                        info={'duration of the poll (in days)'}
                                        name={'duration'}
                                        displayName={'Duration (days)'}
                                        value={selectedPoll.duration}
                                        validationMethod={validatePollParameter}
                                        updateMethod={updatePoll} />
                                </Col>
                            </Row>
                            <Row className="mt-1">
                                <Col>
                                    <C4FReferenceDataSelection
                                        disabled={!editPollAllowed()}
                                        key={'allowChangesPoll'}
                                        info={'indicates, if the vote can be changed, while the poll is still in progress'}
                                        name={'allowChanges'}                                    
                                        displayName={'allowChanges'}
                                        value={selectedPoll.allowChanges}
                                        referenceDataValues={[
                                            { key: true, value: 'yes (true)'},
                                            { key: false, value: 'no (false)'}
                                        ]}
                                        updateMethod={updatePoll}
                                        validationMethod={validatePollParameter}
                                    />
                                </Col>
                                <Col>
                                    <C4FReferenceDataSelection
                                        disabled={!editPollAllowed()}
                                        key={'userRestrictionPoll'}
                                        info={'restrictions for users to participate in poll'}
                                        name={'userRestriction'}                                    
                                        displayName={'Restriction'}
                                        value={selectedPoll.userRestriction}
                                        referenceDataValues={[ 
                                            { key: 'None', value: 'none'},
                                            { key: 'ThirtyRacesOrMore', value: '> 30 races'},
                                            { key: 'Division1', value: 'only division 1'},
                                            { key: 'Division5OrHigher', value: 'at least division 5'},
                                        ]}
                                        updateMethod={updatePoll}
                                        validationMethod={validatePollParameter}
                                    />
                                </Col>
                                <Col>
                                    <C4FReferenceDataSelection
                                        disabled={!editPollAllowed()}
                                        key={'isAnonymousPoll'}
                                        info={'indicates, if poll results will be anonymous'}
                                        name={'isAnonymous'}                                    
                                        displayName={'isAnonymous'}
                                        value={selectedPoll.isAnonymous}
                                        referenceDataValues={[
                                            { key: true, value: 'yes (true)'},
                                            { key: false, value: 'no (false)'}
                                        ]}
                                        updateMethod={updatePoll}
                                        validationMethod={validatePollParameter}
                                    />
                                </Col>
                            </Row>
                            <Row className="mt-2">
                                <Col>
                                    <h5>Questions</h5>
                                    <C4FSimpleTable                                        
                                        key={'itemsPoll'}
                                        highlightCriteriaKey={selectedPollItem ? 'number' : null}
                                        highlightCriteriaValue={selectedPollItem ? selectedPollItem.number : null}
                                        hideFilterButtons={false}
                                        hideColumnVisibility={true}
                                        addRecord={editPollAllowed() ? addPollItem : null}
                                        deleteRecord={editPollAllowed() ? deletePollItem : null}
                                        data={selectedPoll.items.map(i => ({
                                            ...i,
                                            answersFormatted: i.minAnswers !== i.maxAnswers ? i.minAnswers + ' to ' + i.maxAnswers : i.minAnswers
                                        }))}
                                        rowMetadata={[
                                            { columnName: 'type', columnDescription: 'Type', cellClickEvent: setSelectedPollItem },
                                            { columnName: 'question', columnDescription: 'Question', cellClickEvent: setSelectedPollItem },
                                            { columnName: 'answersFormatted', columnDescription: 'Answers', cellClickEvent: setSelectedPollItem }
                                        ]}
                                    />
                                </Col>
                            </Row>
                            {selectedPollItem && editPollAllowed() ?
                                <>
                                    <Row className="mt-1">
                                        <Col>
                                            <C4FReferenceDataSelection
                                                disabled={!editPollAllowed()}
                                                key={'typePollItem'}
                                                info={'type of the poll item, either free text or multiple choice'}
                                                name={'type'}                                    
                                                displayName={'type'}
                                                value={selectedPollItem.type}
                                                referenceDataValues={[ 
                                                    { key: 'FreeText', value: 'free text'},
                                                    { key: 'MultipleChoice', value: 'multiple choice'}
                                                ]}
                                                updateMethod={updatePollItem}
                                                validationMethod={validatePollItemParameter}
                                            />
                                        </Col>
                                        <Col>
                                            <C4FSimpleTextField
                                                disabled={!editPollAllowed()}
                                                key={'minAnswersPollItem'}
                                                info={'indicates minimum number of selected answers in case multiple choice questions. For free text questions, it indicates, if the question needs to be answered'}
                                                name={'minAnswers'}
                                                displayName={'minAnswers'}
                                                value={selectedPollItem.minAnswers}
                                                validationMethod={validatePollItemParameter}
                                                updateMethod={updatePollItem} />
                                        </Col>
                                        <Col>
                                            <C4FSimpleTextField
                                                disabled={!editPollAllowed() || selectedPollItem.type === 'FreeText'}                                                
                                                key={'maxAnswersPollItem'}
                                                info={'indicates minimum number of selected answers in case multiple choice questions'}
                                                name={'maxAnswers'}
                                                displayName={'maxAnswers'}
                                                value={selectedPollItem.maxAnswers}
                                                validationMethod={validatePollItemParameter}
                                                updateMethod={updatePollItem} />
                                        </Col>
                                    </Row>
                                    <Row className="mt-1">
                                        <Col>
                                            <C4FSimpleTextField
                                                disabled={!editPollAllowed()}                                   
                                                key={'textPollItem'}
                                                info={'question to be asked to the user'}
                                                name={'question'}
                                                displayName={'question'}
                                                value={selectedPollItem.question}
                                                validationMethod={validatePollItemParameter}
                                                updateMethod={updatePollItem} />
                                        </Col>
                                    </Row>
                                </>
                            : null }
                            {selectedPollItem && selectedPollItem.type === 'MultipleChoice' ?
                                <Row className="mt-2">
                                    <Col>
                                        <h5>Answers</h5>
                                        <C4FSimpleTable 
                                            key={'optionsPollItem'}
                                            highlightCriteriaKey={selectedPollItemOption ? 'number' : null}
                                            highlightCriteriaValue={selectedPollItemOption ? selectedPollItemOption.number : null}
                                            hideFilterButtons={false}
                                            hideColumnVisibility={true}
                                            indexColumn={true}
                                            addRecord={editPollAllowed() ? addPollItemOption : null}
                                            deleteRecord={editPollAllowed() ? deletePollItemOption : null}
                                            data={selectedPollItem.options ? selectedPollItem.options : []}
                                            rowMetadata={[
                                                { columnName: 'answer', columnDescription: 'Answer', cellClickEvent: setSelectedPollItemOption }]}
                                        />
                                        {selectedPollItemOption && editPollAllowed() ?
                                            <>
                                                <C4FSimpleTextField className="mt-1"   
                                                    disabled={!editPollAllowed()}                                   
                                                    key={'textPollItemOption'}
                                                    info={'answer option'}
                                                    name={'answer'}
                                                    displayName={'answer'}
                                                    value={selectedPollItemOption.answer}
                                                    validationMethod={validatePollParameter}
                                                    updateMethod={updatePollItemOption} />
                                            </>
                                        : null }
                                    </Col>
                                </Row>
                            : null }
                            {selectedPoll.status === 'Draft' && editPollAllowed() ?
                                <Row className="mt-2">
                                    <Col>
                                        <Button 
                                            disabled={!isPollValid() || !hasUnsavedChanges}
                                            variant={'secondary'} size="sm" 
                                            onClick={() => savePoll()}>Save Draft</Button>
                                        <Button className="ml-1" 
                                            disabled={!hasUnsavedChanges}
                                            variant={'secondary'} size="sm" 
                                            onClick={() => revertChanges()}>Revert Changes</Button>
                                        <Button className="ml-1" 
                                            disabled={hasUnsavedChanges}
                                            variant={'secondary'} size="sm" 
                                            onClick={() => transitionPoll('Cancelled')}>Cancel Poll</Button>
                                        <Button className="ml-1"
                                            disabled={hasUnsavedChanges}
                                            variant={'success'} size="sm" 
                                            onClick={() => transitionPoll('Submitted')}>Submit Poll</Button>
                                        {selectedPoll.reviewComment && selectedPoll.reviewComment.length > 0 ? 
                                            <C4FSimpleTextField className="mt-3"   
                                                disabled={true}
                                                key={'reviewCommentPoll'}
                                                name={'reviewComment'}
                                                displayName={'Review Comment'}
                                                value={selectedPoll.reviewComment} />
                                        : null }
                                    </Col>
                                </Row>
                            : null }                            
                            {selectedPoll.status === 'Cancelled' ?
                                <Row className="mt-2">
                                    <Col>
                                        <Button 
                                            disabled={!reativatePollAllowed}
                                            variant={'secondary'} size="sm" 
                                            onClick={() => transitionPoll('Draft')}>Reactivate</Button>
                                    </Col>
                                </Row>
                            : null }                            
                            {selectedPoll.status === 'Submitted' && isAdmin(userInformation) ?
                                <Row className="mt-2">
                                    <Col>
                                        <Button variant={'danger'} size="sm" 
                                            onClick={() => transitionPoll('Draft')}>Reject</Button>
                                        <Button className="ml-1" variant={'success'} size="sm" 
                                            onClick={() => transitionPoll('Approved')}>Approve</Button>
                                        <C4FSimpleTextField className="mt-3"   
                                            key={'reviewCommentPoll'}
                                            info={'comment from approver to creator of poll, in particular relevant when rejecting the poll'}
                                            name={'reviewComment'}
                                            displayName={'Review Comment'}
                                            value={selectedPoll.reviewComment}
                                            validationMethod={validatePollParameter}
                                            updateMethod={updatePoll} />
                                    </Col>
                                </Row>
                            : null }
                        </>
                    : null }
                    {tab === 'details' && selectedPoll && !statusListDesign.includes(selectedPoll.status) ? 
                        <>
                            <Row>
                                <Col>                                
                                    <h5>{selectedPoll.title}</h5>
                                    <ButtonGroup className="mt-1 mb-2">
                                        <Button variant={(!selectedPollItem ? '' : 'outline-') + 'secondary'} size="sm" 
                                            onClick={() => setSelectedPollItem(null)}>Poll Overview</Button>
                                        {selectedPoll.items.map((item, index) => 
                                            <Button variant={(selectedPollItem && selectedPollItem.number === index + 1 ? '' : 'outline-') + 'secondary'} size="sm" 
                                                onClick={() => setSelectedPollItem(selectedPoll.items[index])}>Question {index + 1}</Button>
                                        )}
                                    </ButtonGroup>

                                    {!selectedPollItem ? 
                                        <>
                                            <ul>
                                                <li>Description: {selectedPoll.description}</li>
                                                <li>Duration: {selectedPoll.duration} days, from {selectedPoll.startDate} midnight until {moment(selectedPoll.startDate).add(selectedPoll.duration, 'days').format('YYYY-MM-DD')} midnight</li>
                                                <li>Questions: {selectedPoll.items.length}</li>
                                                <li>Restriction for participation: {selectedPoll.userRestriction}</li>
                                                {selectedPoll.isAnonymous ? 
                                                    <li>Answers remain anonymous</li>
                                                    :
                                                    <li>Answers will be visible for any registered player {selectedPoll.resultsAvailable === 'AfterCompletion' ? 
                                                        'after completion' 
                                                        :
                                                        (selectedPoll.resultsAvailable === 'AfterVoting' ? 'after submitting answers' : '')}</li>
                                                }
                                                {selectedPoll.allowChanges ? 
                                                    <li>Answers can be changed before end of poll</li>
                                                    :
                                                    <li>Answers cannot be changed once they are submitted</li>
                                                }
                                                {selectedPoll.resultsAvailable === 'AfterCompletion' ?
                                                    <li>Results are available after completion of poll</li>
                                                : null }
                                                {selectedPoll.resultsAvailable === 'AfterVoting' ?
                                                    <li>Results are available to user after voting</li>
                                                : null }
                                                {selectedPoll.resultsAvailable === 'Always' ?
                                                    <li>Results are always available to every user</li>
                                                : null }
                                                {selectedPoll.resultsAvailable === 'Never' ?
                                                    <li>Results are never available and remain hidden</li>
                                                : null }
                                            </ul>                                        
                                        </>
                                    : null }
                                </Col>
                            </Row>

                            {selectedPoll.items.length > 0 && selectedPollItem ? 
                                <Row className="mt-2">
                                    <Col>
                                        <h5>{selectedPollItem.question} {pollItemStatus() ? resultEmoji('OK') : resultEmoji('NOK')}</h5>
                                        {selectedPollItem.type === 'FreeText' ? 
                                            <C4FSimpleTextField className="mt-1"
                                                disabled={!votingAllowed()}
                                                key={'answer'}
                                                name={'answer'}
                                                displayName={'Answer'}
                                                value={selectedPollItem.answer ? selectedPollItem.answer : ''}
                                                validationMethod={validatePollItemParameter}
                                                updateMethod={updatePollItem} />
                                            :
                                            <>
                                                {selectedPollItem.minAnswers !== selectedPollItem.maxAnswers ?
                                                    <>Please select {selectedPollItem.minAnswers} to {selectedPollItem.maxAnswers} options ({selectedPollItem.answer.length} selected)</>
                                                    : 
                                                    <>Please select {selectedPollItem.minAnswers} option{selectedPollItem.minAnswers === 1 ? '' : 's'}</>
                                                }
                                                <Form.Group controlId="">
                                                    {selectedPollItem.options.map(o => (
                                                        <>                                                
                                                            <Form.Check key={'question' + selectedPollItem.number + 'option' + o.number}>
                                                                <Form.Check.Input
                                                                    disabled={!votingAllowed()}
                                                                    type={selectedPollItem.maxAnswers > 1 ? 'checkbox' : 'radio'}
                                                                    checked={selectedPollItem.answer.includes(o.number)} 
                                                                    onChange={(e) => updateSelectedOptions(o.number, e.target.checked)} />
                                                                <Form.Check.Label>{o.answer}</Form.Check.Label>
                                                            </Form.Check>
                                                        </>
                                                    ))}
                                                </Form.Group>
                                            </>
                                        }

                                        {selectedPoll.votes.some(v => v.items.some(vi => vi.number === selectedPollItem.number)) ?
                                            <>
                                                
                                                {selectedPollItem.type === 'MultipleChoice' ? 
                                                    <>
                                                        <h5>Aggregated results</h5>
                                                        <C4FSimpleTable 
                                                            key={'multipleChoiceVotesAggregated'}
                                                            hideFilterButtons={true}
                                                            hideColumnVisibility={true}
                                                            data={selectedPollItem.options.map(o => {
                                                                let totalVotes = sum(selectedPoll.votes
                                                                    .filter(v => v.items.some(i => i.number === selectedPollItem.number))
                                                                    .map(v => v.items.find(i => i.number === selectedPollItem.number).answer.length));
                                                                let numberOfVotes = selectedPoll.votes
                                                                    .filter(v => v.items.some(i => i.number === selectedPollItem.number && i.answer.includes(o.number)))
                                                                    .length;                                                        
                                                                return {
                                                                    answer: o.answer,
                                                                    numberOfVotes: numberOfVotes + ' / ' + totalVotes,
                                                                    votePercentage: ((numberOfVotes / totalVotes) * 100).toFixed(1) + '%',
                                                                    numberOfVoters: numberOfVotes + ' / ' + selectedPoll.votes.length,
                                                                    voterPercentage: ((numberOfVotes / selectedPoll.votes.length) * 100).toFixed(1) + '%'
                                                                }})}
                                                            rowMetadata={[
                                                                { columnName: 'answer', columnDescription: 'Answer' },
                                                                { columnName: 'numberOfVotes', columnDescription: '# Votes / Total Votes' },
                                                                { columnName: 'votePercentage', columnDescription: 'Votes %' },
                                                                { columnName: 'numberOfVoters', columnDescription: 'Total Voters' },
                                                                { columnName: 'voterPercentage', columnDescription: 'Voters %' },
                                                            ]}
                                                        />
                                                    </>
                                                    :
                                                    <>
                                                        <h5>Answers</h5>
                                                        <C4FSimpleTable 
                                                            key={'freeTextVotes'}
                                                            hideFilterButtons={true}
                                                            hideColumnVisibility={true}
                                                            data={selectedPoll.votes.map(v => ({
                                                                userId: v.userId,
                                                                userName: v.userName,
                                                                answer: v.items.find(i => i.number === selectedPollItem.number).answer
                                                            }))}
                                                            rowMetadata={
                                                                (selectedPoll.isAnonymous ? 
                                                                [] : [{ columnName: 'userName', columnDescription: 'User' }]).concat(
                                                                [{ columnName: 'answer', columnDescription: 'Answer' }])}
                                                        />
                                                    </>

                                                }
                                            </>
                                        : null }

                                        <Button className="mt-1" variant={'secondary'} size="sm" 
                                            onClick={() => backToPreviousItem()}>previous</Button>
                                        <Button className="mx-1 mt-1" variant={'secondary'} size="sm" 
                                            onClick={() => continueToNextItem()}>next</Button>
                                    </Col>
                                </Row>
                                : 
                                <Row className="mt-2">
                                    <Col>
                                        <h5>{statusListCompleted.includes(selectedPoll.status) || selectedPoll.voted ? 'Your Vote' : 'All Questions'}</h5>
                                        <C4FSimpleTable 
                                            key={'itemsPollExecution'}
                                            hideFilterButtons={true}
                                            hideColumnVisibility={true}
                                            data={selectedPoll.items.map(i => ({ 
                                                ...i, 
                                                answer: i.answer.constructor === Array ? 
                                                    i.answer.map(a => i.options.find(o => o.number === a).answer).join(', ') 
                                                    : 
                                                    i.answer,
                                                status: pollItemStatus(i) ? resultEmoji('OK') : resultEmoji('NOK') }))}
                                            rowMetadata={[
                                                { columnName: 'status', columnDescription: 'OK?' },
                                                { columnName: 'question', columnDescription: 'Question', cellClickEvent: setSelectedPollItem },
                                                { columnName: 'answer', columnDescription: 'Your Answer', cellClickEvent: setSelectedPollItem }
                                            ]}
                                        />
                                    </Col>
                                </Row>
                            }
                            {votingAllowed() ? 
                                <Row className="mt-3">
                                    <Col>
                                        {!selectedPollItem ?
                                            <Button className="mr-1" variant={'primary'} size="sm" 
                                                onClick={() => setSelectedPollItem(selectedPoll.items[0])}>Start</Button>
                                        : null }
                                        <Button className="mr-1" variant={'secondary'} size="sm" 
                                            onClick={() => resetVote()}>Reset</Button>
                                        <Button className="mr-1" variant={'secondary'} size="sm" 
                                            onClick={() => cancelVote()}>Cancel</Button>
                                        <Button className="mr-1" 
                                            disabled={selectedPoll.items.some(pi => !pollItemStatus(pi))}
                                            variant={'success'} size="sm" 
                                            onClick={() => submitVote()}>Submit</Button>
                                    </Col>
                                </Row>
                            : null }
                        </>
                    : null }
                                    
                </Modal.Body>
                <Modal.Footer>
                    <Button className="py-0 m-0" variant="primary" onClick={handleClose}>{'Close'}</Button>
                </Modal.Footer>
            </Modal>
            : null}
    </>
}

export default PollModal;